import { useCallback } from 'react'
import { Contract } from 'web3-eth-contract'

// hooks
import useYam from './useYam'
import { useActiveWeb3React } from '../'

import {
  harvest,
  harvestBeth,
  harvestBake,
  harvestOther,
  getAnkrAddress,
  getOnxAddress,
  getAethAddress,
  commonStakeERC721EarnERC20Harvest,
  commonStakeERC721EarnBakeHarvest
} from '../../sushi/utils'
import { 
  simpleStakeERC721EarnERC20Harvest 
} from '../../sushi/simpleStakeERC721EarnERC20'
import { MINTTOKEN } from '../../constants/bakery'
import { NFTTYPE } from '../../constants/bakery/nft'

import { poolMasterContract } from '../../userType/poolMasterContract'

const useReward = (lpTokenAddress: string, tokenName?: string) => {
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  let masterContract: Contract = poolMasterContract(sushi, tokenName)

  const handleReward = useCallback(
    async (earnToken?: string) => {
      let txHash
      try{
        if (tokenName === MINTTOKEN.ETH2MASTER || tokenName === MINTTOKEN.AETHMASTER) {
          let otherTokenAddress
          switch (earnToken) {
            case 'onx':
              otherTokenAddress = getOnxAddress(sushi)
              txHash = await harvestOther(masterContract, lpTokenAddress, otherTokenAddress, account)
              break
            case 'ankr':
              otherTokenAddress = getAnkrAddress(sushi)
              txHash = await harvestOther(masterContract, lpTokenAddress, otherTokenAddress, account)
              break
            case 'aeth':
              otherTokenAddress = getAethAddress(sushi)
              txHash = await harvestOther(masterContract, lpTokenAddress, otherTokenAddress, account)
              break
            case 'bake':
              txHash = await harvestBake(masterContract, lpTokenAddress, account)
              break
            case 'beth':
              txHash = await harvestBeth(masterContract, lpTokenAddress, account)
              break
          }
        } else if (tokenName && [MINTTOKEN.TKONFTSTAKE, NFTTYPE.GAMEBOX, MINTTOKEN.BMONCNFTSTAKE].includes(tokenName)) {
          txHash = await commonStakeERC721EarnERC20Harvest(masterContract, lpTokenAddress, account)
        } else if (tokenName && [MINTTOKEN.TOYNFTSTAKE].includes(tokenName)) {
          txHash = await simpleStakeERC721EarnERC20Harvest(masterContract, account)
        } else if (tokenName && [MINTTOKEN.BMMNFTSTAKE].includes(tokenName)) {
          txHash = await commonStakeERC721EarnBakeHarvest(masterContract, account)
        } else {
          txHash = await harvest(masterContract, lpTokenAddress, account)
        }
      }catch (e){
        console.log("--e--",e)
      }
      return txHash
    },
    [account, masterContract, lpTokenAddress, tokenName, sushi]
  )

  return { onReward: handleReward }
}

export default useReward
